import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link, useParams } from 'react-router-dom';
import '../css/PrincipalDashboard.css'; 
import axios from 'axios';

const Sidebar = () => {
  const userRole = localStorage.getItem('role');
  const userId = localStorage.getItem('userId') || '1';
  const navigate = useNavigate();
  const { id } = useParams(); // URL se :id check karne ke liye
  const location = useLocation();
  
  const dashboardPath = userRole === 'admin' ? '/admin' : `/admin/principal/${userId}`;

  // LOGIC: Agar URL mein koi ID hai, ya state mein viewMode admin hai, aur dekhne wala admin hai, 
  // tabhi pata chalega ki admin kisi aur ka dashboard dekh raha hai.
  const isAdminViewingUser = (id || location.state?.viewMode === "admin") && userRole === "admin";

  return (
    <aside className="sidebar">
      <nav className="nav-menu">
        <Link to={dashboardPath} className="nav-item active" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <span>🏠</span> Dashboard
        </Link>
        <div className="nav-item"><span>🎓</span> My Enrollments</div>
        
        {/* FIX: Return tab sirf tabhi dikhega jab admin kisi aur ka dashboard check kar raha ho */}
        {isAdminViewingUser && (
          <div className="nav-item" onClick={() => navigate('/admin')} style={{ cursor: 'pointer' }}>
            <span>⬅️</span> Return
          </div>
        )}
      </nav>
    </aside>
  );
};

const CoachingPartnerDashboard = () => {
  const { state } = useLocation();
  const [userData, setUserData] = useState(state?.user || JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Agar coaching name nahi hai, toh API call se profile refresh karo
    if (!userData || !userData.coachingName) {
      fetchFullProfile();
    }
  }, []);

  const fetchFullProfile = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get('https://api.satrixstore.in/api/me', {
        headers: { 
          'Authorization': `Bearer ${token}`
        }
      });
      setUserData(response.data.data);
      localStorage.setItem("user", JSON.stringify(response.data.data));
    } catch (error) {
      console.error("Error fetching coaching profile:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading Coaching Dashboard...</div>;

  const user = userData || {};

  // Coaching Leads (Sample Data)
  const students = [
    { id: 1, name: 'Amit Verma', stream: 'Commerce', course: 'CA Foundation', status: 'Contacted', location: 'Jaipur', contact: '+91 99999 88888' },
    { id: 2, name: 'Sneha Reddy', stream: 'Science (PCM)', course: 'JEE Main', status: 'New Lead', location: 'Hyderabad', contact: '+91 88888 77777' }
  ];

  return (
    <div className="principal-dashboard-root">
      <Sidebar/>
      <div className="principal-dashboard-container">
        <div className="main-content">
          <header className="welcome-header">
            <p>Welcome back, Coaching Partner 👋</p>
            <h1>{user.fullName || "Partner Name"}</h1>
          </header>

          <div className="profile-hero-card">
            <div className="profile-main">
              <div className="avatar">{user.fullName ? user.fullName.charAt(0) : 'C'}</div>
              <div className="info">
                <h3>{user.fullName || "Partner Name"}</h3>
                <p><span>📧</span> {user.email || "coaching@evridya.com"}</p>
                <p><span>📱</span> {user.phoneNumber || "+91 96666 55555"}</p>
                <p><span>📍</span> {user.city || "Delhi"}</p>
              </div>
            </div>
            <div className="stats-grid">
              <div className="stat-item"><span>🏢</span><label>Coaching:</label> <strong>{user.coachingInstituteName || "Apex Institute"}</strong></div>
              <div className="stat-item"><span>🎯</span><label>Specialization:</label> <strong>{user.coachingCoursesOffered || "IIT-JEE / NEET"}</strong></div>
              <div className="stat-item"><span>📈</span><label>Total Leads:</label> <strong>{user.coachingNumberOfStudents || "45"}</strong></div>
            </div>
          </div>

          <div className="table-card">
            <div className="table-header">
              <h3>Referred Student Leads</h3>
              <div className="search-filter">
                <input type="text" placeholder="Search student..." />
              </div>
            </div>
            <table>
              <thead>
                <tr><th>#</th><th>Student Name</th><th>12th Stream</th><th>Target Course</th><th>Location</th><th>Status</th></tr>
              </thead>
              <tbody>
                {students.map((s, index) => (
                  <tr key={s.id}>
                    <td>{index + 1}</td>
                    <td>
                      <strong>{s.name}</strong><br /><small>{s.contact}</small>
                    </td>
                    <td>{s.stream}</td>
                    <td>{s.course}</td>
                    <td>{s.location}</td>
                    <td>
                      <span className={`status-pill ${s.status.toLowerCase().replace(' ', '-')}`}>{s.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoachingPartnerDashboard;